// Mirrors backend/src/models/Afe.js + routes/afes.js. The role list only
// hides controls; the backend enforces it (403) regardless.
export const AFE_MANAGE_ROLES = ["admin", "supervisor"];
export const AFE_TYPES = ["drill", "complete", "workover", "facilities", "other"];
export const AFE_CATEGORIES = ["rig", "rentals", "fluids", "wireline", "frac", "trucking", "labor", "other"];

export function canManageAfes(user) {
  return AFE_MANAGE_ROLES.includes(user?.role);
}

// green under, amber >90% spent, red over budget
export function afeStatusColor(status) {
  if (status === "over") return "#ff4466";
  if (status === "near") return "#ffaa00";
  return "#00cc66";
}
